import React from "react";
import { Helmet } from "react-helmet-async";
export default function SEO(props) {
  const { title, description, name, type } = props;

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title || "Qalort"}</title>
      <meta
        name="description"
        content={description || "Learn from the best mentors"}
      />
      {/* End standard metadata tags */}
      {/* Facebook tags */}
      <meta property="og:type" content={type || "website"} />
      <meta property="og:title" content={title || "Qalort"} />
      <meta
        property="og:description"
        content={description || "Learn from the best mentors"}
      />
      {/* End Facebook tags */}
      {/* Twitter tags */}
      <meta name="twitter:creator" content={name || "Qalort"} />
      <meta name="twitter:card" content={type || "website"} />
      <meta name="twitter:title" content={title || "Qalort"} />
      <meta
        name="twitter:description"
        content={description || "Learn from the best mentors"}
      />
      <link rel="canonical" href={window.location.href} />
      {/* End Twitter tags */}
    </Helmet>
  );
}
